module.exports = __webpack_public_path__ + "img/33-cb35eb.png";